export enum TestIdsEnum {
  CommonButtonSkip = 'button-skip',
  CommonButtonSubmit = 'button-submit',
  CommonButtonContinue = 'button-continue',

  LoginEmailInput = 'login-email-input',
  LoginPasswordInput = 'login-password-input',
  LoginSubmitButton = 'login-submit-button',
  LoginLinkSignUp = 'login-link-sign-up',

  ApplicationSelect = 'application-select',
  ApplicationCreateButton = 'application-create-button',
  ApplicationNameInput = 'application-name-input',
  ApplicationConsumerNameInput = 'application-consumer-name-input',
  ApplicationGoDashboard = 'application-go-dashboard',
  ApplicationGoInvite = 'application-go-invite',
  ApplicationGoIntegrations = 'application-go-integrations',
  ApplicationGoDocumentation = 'application-go-documentation',
}
